import { Input, Label } from "@nexus/ui";
import { useTranslation } from "react-i18next";

import type { PersonaOpportunityQueryTuning } from "../../../types/persona-opportunities.types.js";

type TuningFieldKey = keyof PersonaOpportunityQueryTuning;

const TUNING_FIELDS: TuningFieldKey[] = [
  "candidatePoolSize",
  "anglesReturned",
  "maxAnglesPerFeature",
  "minBrandsPerFeature",
  "stickDays",
];

export interface PersonaQueryTuningFieldsProps {
  value: PersonaOpportunityQueryTuning;
  onChange: (value: PersonaOpportunityQueryTuning) => void;
  disabled?: boolean;
}

export function PersonaQueryTuningFields({ value, onChange, disabled }: PersonaQueryTuningFieldsProps) {
  const { t } = useTranslation();

  function handleFieldChange(field: TuningFieldKey, raw: string) {
    const parsed = Number.parseInt(raw, 10);
    onChange({
      ...value,
      [field]: Number.isNaN(parsed) ? 0 : parsed,
    });
  }

  return (
    <div className="grid gap-3 sm:grid-cols-2">
      {TUNING_FIELDS.map((field) => (
        <div key={field} className="flex flex-col gap-1.5">
          <Label htmlFor={`persona-tuning-${field}`}>
            {t(`personaOpportunities.queryTuning.${field}.label`)}
          </Label>
          <Input
            id={`persona-tuning-${field}`}
            type="number"
            min={1}
            step={1}
            inputMode="numeric"
            value={value[field] || ""}
            onChange={(event) => handleFieldChange(field, event.target.value)}
            disabled={disabled}
          />
          <p className="text-[11px] leading-snug text-muted-foreground/55">
            {t(`personaOpportunities.queryTuning.${field}.hint`)}
          </p>
        </div>
      ))}
    </div>
  );
}
